import client from 'core/axios';
import handleError from 'core/axios/handleError';
import { handleJSONResponse } from 'core/axios/handleResponse';
import RequestMethod from 'core/axios/RequestMethod';

export const getProject = ({ module, version = 'v1' }) =>
  client
    .request({
      url: `${version}/guided-setup/projects/get-project/${module}/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getProjectContext = ({ projectId, version = 'v1' }) =>
  client
    .request({
      url: `${version}/guided-setup/projects/${projectId}/context/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getProjectIsSyncing = ({ projectId, version = 'v1' }) =>
  client
    .request({
      url: `${version}/guided-setup/projects/${projectId}/is-syncing/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateProject = ({ payload, projectId, version = 'v1' }) =>
  client
    .request({
      url: `${version}/guided-setup/projects/${projectId}/`,
      method: RequestMethod.PATCH,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const setupProject = ({ payload, projectId, version = 'v1' }) =>
  client
    .request({
      url: `${version}/guided-setup/projects/${projectId}/setup-project/`,
      method: RequestMethod.PATCH,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const enableSchools = ({ payload, projectId, version = 'v1' }) =>
  client
    .request({
      url: `${version}/guided-setup/projects/${projectId}/enable-schools/`,
      method: RequestMethod.PATCH,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getUserTask = ({ userTaskId, version = 'v1' }) =>
  client
    .request({
      url: `${version}/guided-setup/user-tasks/${userTaskId}/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const manuallyUpdateUserTask = ({
  payload,
  userTaskId,
  version = 'v1',
}) =>
  client
    .request({
      url: `${version}/guided-setup/user-tasks/${userTaskId}/manual-update/`,
      method: RequestMethod.PATCH,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getRoles = ({ params, version = 'v1' }) =>
  client
    .request({
      url: `${version}/guided-setup/roles/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateOrCreateUserProjectRole = ({ payload, version = 'v1' }) =>
  client
    .request({
      url: `${version}/guided-setup/user-project-roles/`,
      method: RequestMethod.POST,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getUserProjectRoles = ({ params, version = 'v1' }) =>
  client
    .request({
      url: `${version}/guided-setup/user-project-roles/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);
